<span>{{ firstBit }}</span
><span class="highlighted">{{ middleBit }}</span
><span>{{ lastBit }}</span>
